import {NavLink} from "react-router-dom";

export const CustomerDetailPageLink = (props: { id: string }) => {

    return (
        <NavLink to={`/customers/${props.id}`}>{props.id}</NavLink>
    )

}
